export const environment = {
  production: true,
  tag: 'qa',
  apiUrl: 'https://gw.qa.watchtower.boemm.eu/v1/watchtower/api',
  auth: {
    loginPage:
      'https://watchtower-qa.auth.eu-central-1.amazoncognito.com/login?client_id=1bbmgvf031f4t6etkf975gbb0d&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https%3A%2F%2Fgw.qa.watchtower.boemm.eu%2Fv1%2Fsignin',
  },
};
